import { render, staticRenderFns } from "./EnglishReferencePane.vue?vue&type=template&id=4187dcd0&"
import script from "./EnglishReferencePane.vue?vue&type=script&lang=js&"
export * from "./EnglishReferencePane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports